/** @format */

import { useTheme } from '@/entities/theme/model'
import { ShortcutContainer, Badge, IconWrapper, Title } from './style'

interface ShortcutButtonProps {
  theme?: Record<string, string>
  label: string
  icon: React.ReactNode
  badgeIcon?: React.ReactNode
  badgeCount?: number
  bgColor?: string
  badgeColor?: string
  width?: string
  height?: string
  iconwidth?: string
  iconheight?: string
  textColor?: string
  onClick: () => void
  isOnProcess?: boolean
  isMini?: boolean
  menu?: boolean
  menuMini?: boolean
  collapsed?: boolean
}

const ShortcutButton = ({
  collapsed,
  label,
  icon,
  badgeCount = 0,
  bgColor = '#8fcf7b',
  badgeColor = '#fbb034',
  width = '200px',
  height = '120px',
  textColor = '#fff',
  onClick,
  isOnProcess = true,
  isMini = false,
  menu = false,
  menuMini,
  iconwidth,
  iconheight,
}: ShortcutButtonProps) => {
  const { theme } = useTheme()
  return !isMini && !menu ? (
    <ShortcutContainer
      $collapsed={collapsed}
      $bgColor={bgColor}
      width={width}
      height={height}
      onClick={onClick}
      $isOnProcess={isOnProcess}
    >
      {!collapsed && (
        <Title $bgColor={bgColor} $textColor={textColor} theme={theme}>
          {label}
        </Title>
      )}
      {badgeCount > 0 && (
        <Badge $badgeColor={badgeColor}>{`+${badgeCount}`}</Badge>
      )}

      <IconWrapper
        $collapsed={collapsed}
        width={iconwidth ?? '64px'}
        height={iconheight ?? '64px'}
      >
        {icon}
      </IconWrapper>
    </ShortcutContainer>
  ) : menu ? (
    <ShortcutContainer
      $collapsed={collapsed}
      $bgColor={bgColor}
      width={width}
      height={height}
      onClick={onClick}
      $isOnProcess={isOnProcess}
      $menu={menu}
    >
      {!collapsed && (
        <Title
          $bgColor={bgColor}
          $textColor={textColor}
          $menu={menu}
          theme={theme}
        >
          {label}
        </Title>
      )}
      {badgeCount > 0 && (
        <Badge $menu={menu} $badgeColor={badgeColor}>{`+${badgeCount}`}</Badge>
      )}

      <IconWrapper
        $collapsed={collapsed}
        width={iconwidth ?? '64px'}
        height={iconheight ?? '64px'}
        $menu={menu}
        theme={theme}
      >
        {icon}
      </IconWrapper>
    </ShortcutContainer>
  ) : menuMini ? (
    <ShortcutContainer
      $collapsed={collapsed}
      $bgColor={bgColor}
      width={width}
      height={height}
      onClick={onClick}
      $isOnProcess={isOnProcess}
      $isMini={isMini}
      $menuMini={menuMini}
    >
      {!collapsed && (
        <Title
          $bgColor={bgColor}
          $textColor={textColor}
          $menuMini={menuMini}
          theme={theme}
        >
          {label}
        </Title>
      )}
      {badgeCount > 0 && (
        <Badge $badgeColor={badgeColor}>{`+${badgeCount}`}</Badge>
      )}

      <IconWrapper
        $collapsed={collapsed}
        width={iconwidth ?? '56px'}
        height={iconheight ?? '56px'}
        $isMini={isMini}
      >
        {icon}
      </IconWrapper>
    </ShortcutContainer>
  ) : (
    <ShortcutContainer
      $collapsed={collapsed}
      $bgColor={bgColor}
      width={width}
      height={height}
      onClick={onClick}
      $isOnProcess={isOnProcess}
      $isMini={isMini}
      theme={theme}
    >
      {badgeCount > 0 && (
        <Badge $badgeColor={badgeColor}>{`+${badgeCount}`}</Badge>
      )}

      <IconWrapper $isMini={isMini}>{icon}</IconWrapper>
      {!collapsed && (
        <Title
          $bgColor={bgColor}
          $textColor={textColor}
          $length={label.length}
          $isMini={isMini}
          theme={theme}
        >
          {label}
        </Title>
      )}
    </ShortcutContainer>
  )
}

export default ShortcutButton
